export default __webpack_public_path__ + "static/media/shopimg1.ed167596.jpg";